<div class="ss" role="search">
  <div class="ss-field">
    <i class="fa fa-search ss-icon" aria-hidden="true"></i>
    <input
      type="text"
      class="ss-input"
      placeholder="Search people, groups, posts"
      aria-label="Search people, groups and posts"
      autocomplete="off"
      spellcheck="false"
      maxlength="80"
      [value]="query"
      (input)="onInput($any($event.target).value)"
      (focus)="open = true"
      (click)="open = true"
      (keydown.enter)="openFirst()" />
    @if (query) {
      <button type="button" class="ss-clear" aria-label="Clear search" (click)="clear()">&times;</button>
    }
  </div>

  @if (open && hasQuery) {
    <div class="ss-panel">
      @if (loading) {
        <p class="ss-note">Searching…</p>
      } @else if (failed) {
        <p class="ss-note">Search isn't available right now. Please try again.</p>
      } @else if (isEmpty) {
        <p class="ss-note">No results for "{{ results?.query }}"</p>
      } @else if (results) {
        @if (results.people.length) {
          <h4 class="ss-heading">People</h4>
          @for (person of results.people; track person.id) {
            <button type="button" class="ss-row ss-person" (click)="openPerson(person)">
              <span class="ss-avatar">
                @if (person.avatar) {
                  <img [src]="avatarUrl(person.avatar)" alt="" (error)="person.avatar = null" />
                } @else {
                  {{ initials(person.name) }}
                }
              </span>
              <span class="ss-text">
                <span class="ss-title">{{ person.name }}</span>
                @if (person.handle) {
                  <span class="ss-sub">&#64;{{ person.handle }}</span>
                }
              </span>
            </button>
          }
        }

        @if (results.groups.length) {
          <h4 class="ss-heading">Groups</h4>
          @for (group of results.groups; track group.kind + group.id) {
            <button type="button" class="ss-row ss-group" (click)="openGroup(group)">
              <span class="ss-avatar ss-avatar-icon">
                <i class="fa" [class.fa-map-o]="group.kind === 'map'" [class.fa-gamepad]="group.kind === 'game'" [class.fa-users]="group.kind === 'community'"></i>
              </span>
              <span class="ss-text">
                <span class="ss-title">{{ group.name }}</span>
                <span class="ss-sub">{{ group.kind === 'map' ? 'Map group' : group.kind === 'game' ? 'Game group' : 'Community' }}</span>
              </span>
            </button>
          }
        }

        @if (results.posts.length) {
          <h4 class="ss-heading">Posts</h4>
          @for (post of results.posts; track post.id) {
            <button type="button" class="ss-row ss-post" (click)="openPost(post)">
              <span class="ss-text">
                <span class="ss-title">
                  {{ post.author.name }}
                  <span class="ss-sub">· {{ post.group_name || post.game_group_name || post.community_name || 'Personal post' }}</span>
                </span>
                @if (post.activity) {
                  <span class="ss-label">{{ post.activity }}</span>
                }
                <span class="ss-snippet">{{ snippet(post) }}</span>
              </span>
            </button>
          }
        }
      }
    </div>
  }
</div>
